module.exports = __webpack_public_path__ + "static/media/img_payment@3x.e7501074.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_payment@3x.png
// module id = 1064
// module chunks = 0